import {coreApi} from '~/services/core'

export const consignmentImporterService = {
  getAll: async () => coreApi.get(`importer-consignment`),
  getById: async (id) => coreApi.get(`importer-consignment?id=${id}`),
  create: async (data) => coreApi.post(`importer-consignment`, data),
  update: async (data) => coreApi.put(`importer-consignment`, data),
  paginate: async (offset) => coreApi.get(`importer-consignment/${offset}`),
}